import { createRouter, createWebHistory } from 'vue-router';

import LoginView from './components/LoginView.vue';
import SupportHub from './components/SupportHub.vue';
//import SupportHubInteractive from './components/SupportHubInteractive.vue';
// import SupportHubInteractiveAll from './components/SupportHubInteractiveAll.vue';

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', name: 'Login', component: LoginView },
  { 
    path: '/support-hub', 
    name: 'SupportHub', 
    component: SupportHub, 
    meta: { requiresAuth: true }, 
  },
  // { path: '/support-hub-interactive', name: 'SupportHubInteractive', component: SupportHubInteractive },
  // { path: '/support-hub-interactive-all', name: 'SupportHubInteractiveAll', component: SupportHubInteractiveAll },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = document.cookie.includes('support_token');

  if (to.meta.requiresAuth && !isLoggedIn) {
    return next('/login');
  }

  next();
});

export default router;